import React from "react";
import { useLang } from "../contexts/LangContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { Button } from "../components/ui/button";
import { Coins } from "lucide-react";

const SYMBOLS = { EUR: "€", USD: "$", GBP: "£", CHF: "₣" };

export default function CurrencySelector() {
  const { currency, setCurrency, supportedCurrencies } = useLang();
  const list = supportedCurrencies && supportedCurrencies.length ? supportedCurrencies : ["EUR", "USD", "GBP", "CHF"];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="currency-selector"
          variant="ghost"
          size="sm"
          className="gap-1.5 text-xs font-medium uppercase tracking-[0.14em]"
          aria-label="Currency"
        >
          <Coins className="h-3.5 w-3.5" />
          <span>{currency}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {list.map((c) => (
          <DropdownMenuItem
            key={c}
            data-testid={`currency-option-${c}`}
            onClick={() => setCurrency(c)}
            className={c === currency ? "font-semibold" : ""}
          >
            <span className="mr-2 inline-block w-4 text-center">{SYMBOLS[c] || ""}</span>{c}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
